<template>
  <section
    v-if="display"
    id="wine-features-region"
    class="wine-features"
  >
    <!-- <SmoothReflow> -->
    <section class="wine-feature-actions">
      <b-container>
        <b-row>
          <b-col>
            <div class="wine-features-dropdown-display">
              <b-form-select
                v-model="activePane"
                class="wine-features-dropdown"
              >
                <b-form-select-option
                  v-for="(paneOption, idx) in panes"
                  :key="`dropdown-item-${idx}`"
                  :value="paneOption.id"
                >
                  {{ paneOption.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <!-- / Dropdown -->

            <!-- Desktop Display -->
            <div class="wine-features-tabs-display">
              <ul class="wine-features-tabs">
                <li
                  v-for="paneTab in panes"
                  :key="`tab-item-${paneTab.id}`"
                  :class="`${(paneTab.id === activePane) ? 'active': ''}`"
                  :tabindex="0"
                  class="tab-item"
                  @click="activePane = paneTab.id"
                  @keyup.enter="activePane = paneTab.id"
                >
                  <div class="tab-title">
                    {{ paneTab.name }}
                  </div>
                </li>
              </ul>
            </div>
            <!-- / Desktop Display -->
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section
      v-if="activePane && panes[activePane]"
      class="wine-feature-content"
    >
      <component
        :is="activeContent"
        :reviews="reviewsData"
        :awards="awardsData"
        :technical-notes="technicalNotesData"
        :wine-making-notes="wineMakingNotesData"
        :tasting-notes="tastingNotes"
        :faqs="faqsData"
      />
    </section>
    <!-- </SmoothReflow> -->
  </section>
</template>

<script>
import wineMakingNotesSection from './WineMakingNotes'
import reviewsAndAwardsSection from './ReviewsAndAwards'
import technicalNotesSection from './TechnicalNotesSection'
import faqsSection from './Faqs'

// import SmoothReflow from "~/components/generic/content-display/SmoothReflow.vue";

export default {
  name: 'wine-feature-section',
  components: {
    wineMakingNotesSection,
    reviewsAndAwardsSection,
    technicalNotesSection,
    faqsSection
  },
  props: {
    wineMakingNotesData: {
      type: [Array, Object],
      required: true
    },
    reviewsData: {
      type: Array,
      required: true
    },
    tastingNotes: {
      type: [Array, Object],
      required: true
    },
    awardsData: {
      type: Array,
      required: true
    },
    technicalNotesData: {
      type: Array,
      required: true
    },
    faqsData: {
      type: Array,
      required: false,
      default: () => {}
    },
    initialPane: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {
      activePane: null
    }
  },
  created() {
    this.setFirstActivePane()
  },
  computed: {
    panes() {
      const panes = {}

      if (this.technicalNotesData.length > 0) {
        panes['technical-notes'] = {
          name: 'Technical',
          id: 'technical-notes',
          component: technicalNotesSection
        }
      }

      if (this.awardsData.length > 0 || this.reviewsData.length > 0) {
        panes['reviews-and-awards'] = {
          name: 'Reviews & Awards',
          id: 'reviews-and-awards',
          component: reviewsAndAwardsSection
        }
      }

      if (this.wineMakingNotesData.length > 0 || this.tastingNotes.length > 0) {
        panes['wine-making-notes'] = {
          name: 'Notes',
          id: 'wine-making-notes',
          component: wineMakingNotesSection
        }
      }

      if (Object.keys(this.faqsData).length > 0) {
        panes.faqs = {
          name: 'FAQs',
          id: 'faqs',
          component: faqsSection
        }
      }

      return panes
    },
    display() {
      return Object.keys(this.panes).length > 0
    },
    activeContent: function() {
      return this.panes[this.activePane].component
    }
  },
  mounted() {
    this.checkInitialPane()
  },
  methods: {
    setFirstActivePane() {
      this.activePane = Object.keys(this.panes).shift()
    },
    checkInitialPane() {
      if (this.initialPane !== '') {
        this.changePane(this.initialPane)
      }
    },
    changePane(paneID) {
      try {
        const panes = Object.keys(this.panes).reduce((acc, val) => {
          const pane = this.panes[val]
          acc.push(pane.id)
          return acc
        }, [])

        if (panes.includes(paneID)) {
          this.pane = paneID
        }
        else {
          throw new Error(`Unable to set activate pane: ${paneID} as this pane does not exist as an option.`)
        }
      }
      catch (e) {
        console.error(e)
      }
    }
  },
  watch: {
    '$route.fullPath': {
      handler: function(updated, old) {
        this.activePane = null
        this.setFirstActivePane()
        this.checkInitialPane()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.wine-feature-actions {
  margin-bottom: 2em;
}
.wine-features-dropdown {
  option {
    color: var(--vc-text-color);
  }
}
.wine-features {
  background: var(--vc-card-background-color);
  color: var(--vc-text-color);
  padding: 3em 0em;
}
.wine-features-dropdown-display {
  @include media-breakpoint-up(md) {
    display: none;
  }
}
.wine-features-tabs-display {
  display: none;
  @include media-breakpoint-up(md) {
    display: flex;
    justify-content: center;
  }
}

.custom-select {
  height: 3.5em;
  border: 1px solid var(--vc-border-color);
  outline: none;
}
.wine-features-tabs {
  margin: 1em 0em;
  padding: 0;

  display: flex;
  justify-content: center;
  .tab-item {
    display: flex;
  }
  .tab-item {
    list-style: none;
    margin: 0em;
    padding: 0em 1.5em 0em 1.5em;
    cursor: pointer;
    position: relative;
    &:not(:last-child) {
      border-right: 1px solid var(--vc-border-color);
    }
    .tab-title {
      transition: transform 0.3s ease-in-out;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: -0.25em;
        height: 2px;
        width: 100%;
        background: var(--vc-border-color);
        z-index: 0;
        transition: opacity 0.25s ease-in-out,
          height 0.25s cubic-bezier(0.6, 0, 0.4, 1);
        opacity: 0;
      }
    }
    @include hover {
      .tab-title {
        transform: translateY(-0.5em);
      }
    }
    @include hover-focus {
      outline: none;
      .tab-title {
        &::before {
          opacity: 1;
        }
      }
    }
    &.active {
      .tab-title {
        color: var(--vc-link-color);
        &::before {
          background: var(--vc-link-color);
          opacity: 1;
        }
      }
    }
  }
  .tab-title {
    font-size: 1.1em;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

::v-deep  .faq-list .faq-category .faqs .faq .faq-heading .faq-heading-content .faq-expand-icon svg {
  fill: var(--vc-highlight-action-background-color) !important;
}

::v-deep  .faq-list .faq-category .faqs .faq .faq-heading .faq-heading-content .faq-text {
  color: var(--vc-link-color);
}
</style>
